import { INIT_DIALOG, OPEN_DIALOG, CLOSE_DIALOG, TOGGLE_DIALOG } from "@stofloos/actions/dialog";

const initialState = {};

const dialog = (state = initialState, action) => {
	switch (action.type) {
		case INIT_DIALOG:
			return {
				...state,
				[action.dialogId]: {
					active: state.active
				}
			};
		case OPEN_DIALOG:
			return {
				...state,
				[action.dialogId]: {
					active: true,
					event: action.event
				}
			};
		case CLOSE_DIALOG:
			return {
				...state,
				[action.dialogId]: {
					active: false
				}
			};
		case TOGGLE_DIALOG:
			return {
				...state,
				[action.dialogId]: {
					active: !state.active
				}
			};
		default:
			return state;
	}
};

export default dialog;
